// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const badge: MarkdocTagRegistration = {
  component: 'Badge',
  tag: 'badge',
  selfClosing: true,
  children: [],
  attributes: {
    color: {
      type: String,
      default: 'gray',
      description: `Can be 'gray', 'blue', 'cyan', 'green', 'yellow', or 'red'`,
    },
    icon: {
      type: String,
      description: `Sail icon name (go/Sail)`,
    },
    iconPosition: {
      type: String,
      default: 'right',
      description: `Position of icon. Can be 'left' or 'right'`,
    },
    label: {
      type: String,
      localizable: true,
    },
  },
};
